import {
  Grid,
  Paper,
  TextField,
  MenuItem,
  Button,
  Stack,
  Alert,
  AlertTitle,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Chip,
  LinearProgress,
  Typography,
  Divider,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import Title from "../Principal/Title";
import Copyright from "../Principal/Copyright";

import LoadingButton from "@mui/lab/LoadingButton";
import List from "@mui/material/List";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const POLL_INTERVAL_MS = 1200;

function statusChipColor(status) {
  switch (status) {
    case "PENDING":
      return "warning";
    case "RUNNING":
      return "info";
    case "DONE":
      return "success";
    case "ERROR":
      return "error";
    default:
      return "default";
  }
}

export default function CifrarDescifrar() {
  const [separator, setSeparator] = React.useState("E");
  const [linesToCifre, setLinesToCifre] = React.useState("");
  const [rows, setRows] = React.useState([]);
  var [openResult, setOpenResult] = React.useState(false);

  const [value, setValue] = useState("numbers");
  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loadingEncrypt, setLoadingEncrypt] = useState(false);
  const [loadingDecrypt, setLoadingDecrypt] = useState(false);

  const [openError, setOpenError] = useState(false);
  const [messageError, setMessageError] = useState("");

  // ---- Jobs (solo para spreadSheet)
  const [job, setJob] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [polling, setPolling] = useState(false);

  const isJobActive = useMemo(() => {
    return job?.status === "PENDING" || job?.status === "RUNNING";
  }, [job]);

  const authHeaders = useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("token"),
    }),
    []
  );

  const handleCloseModals = () => {
    setOpenError(false);
    setOpenSuccess(false);
  };

  const handleOptionChange = (e) => {
    setValue(e.target.value);
    setRows([]);
    setOpenResult(false);
    setJob(null);
    setJobId(null);
    setPolling(false);
    setLoadingEncrypt(false);
    setLoadingDecrypt(false);
  };

  const onChangeSeparator = (e) => {
    setSeparator(e.target.value);
  };

  const onChangeLines = (event) => {
    const v = event.target.value;
    setLinesToCifre(v);
    const count = v.split(separator === "E" ? "\n" : separator).length;
    if (count > 30000) {
      setOpenError(true);
      setMessageError("No se pueden procesar más de 30000 móviles");
      setLinesToCifre("");
    }
  };

  const onClickCifrar = () => {
    setLoadingEncrypt(true);

    axios
      .post(
        process.env.REACT_APP_URL_API_ENCRYPTION + "/encrypt-lines",
        {
          lines: linesToCifre,
          typeSeparation: separator,
        },
        {
          headers: authHeaders
        }
      )
      .then(function (response) {
        var responseBack = response.data.data.decryptedLine.split("\n");
        var textInputUser = linesToCifre.split(
          separator === "E" ? "\n" : separator
        );

        const data = responseBack.map((enc, idx) => ({
          id: idx,
          encrypted: enc,
          decrypted: textInputUser[idx],
        }));

        setRows(data);
        setOpenResult(true);
      })
      .catch(function (error) {
        setOpenError(true);
        setMessageError(error?.message || "Error cifrando");
      })
      .finally(() => setLoadingEncrypt(false));
  };

  const onClickDecifrar = () => {
    setLoadingDecrypt(true);

    axios
      .post(
        process.env.REACT_APP_URL_API_ENCRYPTION + "/decrypt-lines",
        {
          lines: linesToCifre,
          typeSeparation: separator,
        },
        {
          headers: authHeaders
        }
      )
      .then(function (response) {
        var responseBack = response.data.data.decryptedLine.split("\n");
        var textInputUser = linesToCifre.split(
          separator === "E" ? "\n" : separator
        );

        const data = responseBack.map((dec, idx) => ({
          id: idx,
          encrypted: textInputUser[idx],
          decrypted: dec,
        }));

        setRows(data);
        setOpenResult(true);
      })
      .catch(function (error) {
        setOpenError(true);
        setMessageError(error?.message || "Error descifrando");
      })
      .finally(() => setLoadingDecrypt(false));;
  };


  const startSpreadsheetJob = async (type) => {
    // type: "ENCRYPT" | "DECRYPT"
    try {
      setJob(null);
      setJobId(null);
      setPolling(false);

      if (!linesToCifre.trim()) {
        throw new Error("Debes ingresar la URL de Google Sheets");
      }

      if (type === "ENCRYPT") setLoadingEncrypt(true);
      if (type === "DECRYPT") setLoadingDecrypt(true);

      const endpoint =
        type === "ENCRYPT" ? "/updateEncrypted" : "/updateDecrypted";

      const payload = JSON.stringify(linesToCifre.trim());

      const res = await axios.post(
        process.env.REACT_APP_URL_API_GOOGLESHEET + endpoint,
        payload,
        { headers: authHeaders }
      );

      const newJobId = res?.data?.jobId;
      if (!newJobId) throw new Error("No se recibió jobId del backend");

      setJobId(newJobId);
      setPolling(true);

      // primer fetch inmediato
      await fetchJob(newJobId);
    } catch (e) {
      setOpenError(true);
      setMessageError(e?.message || "Error iniciando el job");
    } finally {
      setLoadingEncrypt(false);
      setLoadingDecrypt(false);
    }
  };

  const fetchJob = async (id) => {
    const res = await axios.get(
      process.env.REACT_APP_URL_API_GOOGLESHEET + `/jobs/${id}`,
      { headers: authHeaders }
    );
    return res.data;
  };

  // Polling cuando hay jobId
  useEffect(() => {
    if (!jobId || !polling) return;

    let cancelled = false;
    const tick = async () => {
      try {
        const data = await fetchJob(jobId);
        if (cancelled) return;

        setJob(data);

        if (data?.status === "DONE") {
          setPolling(false);
          setLinesToCifre("");
          setOpenSuccess(true);
          setSuccessMessage(
            `Proceso finalizado. Filas procesadas: ${data?.processedRows ?? 0}`
          );
        }

        if (data?.status === "ERROR") {
          setPolling(false);
          setOpenError(true);
          setMessageError(data?.error || data?.message || "El job falló");
        }
      } catch (e) {
        if (cancelled) return;
        setPolling(false);
        setOpenError(true);
        setMessageError(e?.message || "Error consultando el estado del job");
      }
    };

    tick();
    const interval = setInterval(tick, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };

  }, [jobId, polling]);


  const tablaResponse = (
    <Grid item xs={12}>
      <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
        <Title>Resultado</Title>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Cifrado</b>
              </TableCell>
              <TableCell>
                <b>Descifrado</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.encrypted}</TableCell>
                <TableCell>{row.decrypted}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Copyright />
    </Grid>
  );

    // Panel de estado Job (spreadSheet)
    const jobPanel = value === "spreadSheet" && (job || isJobActive) && (
      <Paper sx={{ mt: 2, p: 2, borderRadius: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography fontWeight={600}>Estado del proceso</Typography>
            <Chip
              size="small"
              label={job?.status || "INICIANDO"}
              color={statusChipColor(job?.status)}
              variant="outlined"
            />
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {job?.type ? `Tipo: ${job.type}` : ""}
          </Typography>
        </Stack>
  
        <Divider sx={{ my: 1.5 }} />
  
        {(job?.status === "PENDING" || job?.status === "RUNNING" || polling) && (
          <Stack spacing={1}>
            <LinearProgress />
            <Typography variant="body2" color="text.secondary">
              {job?.message || "Procesando..."}
            </Typography>
  
            <Stack direction="row" spacing={2}>
              <Typography variant="body2">
                <b>Filas procesadas:</b> {job?.processedRows ?? 0}
              </Typography>
              <Typography variant="body2">
                <b>Batch size:</b> {job?.batchSize ?? "-"}
              </Typography>
              <Typography variant="body2">
                <b>Último inicio:</b> {job?.lastBatchStartRow ?? "-"}
              </Typography>
            </Stack>
          </Stack>
        )}
  
        {job?.status === "DONE" && (
          <Alert severity="success" sx={{ mt: 1 }}>
            Terminado. Filas procesadas: <b>{job?.processedRows ?? 0}</b>
          </Alert>
        )}
  
        {job?.status === "ERROR" && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {job?.error || job?.message || "Error en el proceso"}
          </Alert>
        )}
      </Paper>
    );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8} lg={9}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 360,
            borderRadius: 2,
          }}
        >
          <Title>Cifrar/Descifrar</Title>

          <FormControl>
            <FormLabel> Escoge formato a cifrar </FormLabel>
            <RadioGroup
              row
              name="input-sheet"
              onChange={handleOptionChange}
              value={value}
            >
              <FormControlLabel value="numbers" control={<Radio />} label="Lineas" />
              <FormControlLabel value="spreadSheet" control={<Radio />} label="Google Sheet" />
            </RadioGroup>
          </FormControl>

          <TextField
            label={value === "numbers" ? "Ingrese los móviles" : "Ingrese la Url de Google Sheets"}
            variant="outlined"
            fullWidth
            multiline
            value={linesToCifre}
            onChange={onChangeLines}
            InputProps={{ rows: 3 }}
            style={{ width: "100%", height: "100%" }}
            disabled={value === "spreadSheet" && isJobActive} // evita cambiar URL mientras corre
          />

          <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
            <TextField
              select
              label="Tipo separador"
              value={separator}
              onChange={onChangeSeparator}
              style={value === "numbers" ? null : { display: "none" }}
            >
              <MenuItem value="E">Salto de linea</MenuItem>
              <MenuItem value=";">;</MenuItem>
              <MenuItem value=",">,</MenuItem>
            </TextField>

            <LoadingButton
              size="small"
              variant="contained"
              loading={loadingEncrypt}
              disabled={linesToCifre.trim().length === 0 || isJobActive}
              onClick={() => {
                if (value === "numbers") onClickCifrar();
                else startSpreadsheetJob("ENCRYPT");
              }}
            >
              <span>Cifrar</span>
            </LoadingButton>

            <LoadingButton
              size="small"
              variant="contained"
              loading={loadingDecrypt}
              disabled={linesToCifre.trim().length === 0 || isJobActive}
              onClick={() => {
                if (value === "numbers") onClickDecifrar();
                else startSpreadsheetJob("DECRYPT");
              }}
            >
              <span>Descifrar</span>
            </LoadingButton>
          </Stack>

          {/* panel status job */}
          {jobPanel}
        </Paper>
      </Grid>

      <Grid item xs={12} md={4} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 320,
          }}
          style={{ overflowY: "auto" }}
        >
          <Title>Instrucciones</Title>
          <List color="text.secondary" sx={{ fontSize: 13 }}>
            <li>Debe escoger qué formato cifrar.</li>
            {value === "numbers" ? (
              <ul style={{ padding: "10px" }}>
                <li>
                  Debe seleccionar un tipo de separador para cada móvil (salto
                  de línea, ; o ,), por defecto está el salto de línea.
                </li>
                <li>El máximo de móviles no debe superar los 30.000.</li>
                <li>
                  Si el móvil a cifrar supera los 15 caracteres, no se cifrará.
                </li>
                <li>
                  Si el móvil a descifrar supera los 33 caracteres, no se
                  descifrará.
                </li>
              </ul>
            ) : (
              <ul style={{ padding: "10px" }}>
                <li>Abra el enlace del archivo de hoja de cálculo.</li>
                <li>
                  Asegúrese de que los valores a cifrar o descifrar estén todos
                  en la columna A.
                </li>
                <li>
                  En la parte superior derecha encontrará un botón para
                  compartir. Tendrá que dar acceso para compartir.
                </li>
                <li>
                  Una vez que haga clic en compartir, aparecerá un menú en la
                  pantalla, vaya a la parte de acceso general.
                </li>
                <li>
                  Escoja la opción "Público: cualquiera con el enlace puede
                  editar", verifique que la opción de editor esté seleccionada.
                </li>
                <li>
                  Por último, haga clic en el botón "Compartir enlace" y pegue
                  el enlace que ha sido generado en la caja de texto.
                </li>
              </ul>
            )}
          </List>
        </Paper>
      </Grid>

      {openResult ? tablaResponse : null}

      <Modal open={openError} onClose={handleCloseModals}>
        <Alert severity="error" sx={style}>
          <AlertTitle>Upss!!!</AlertTitle>
          {messageError}
        </Alert>
      </Modal>

      <Modal open={openSuccess} onClose={handleCloseModals}>
        <Alert severity="success" sx={style}>
          <AlertTitle> Exitoso!</AlertTitle>
          {successMessage}
        </Alert>
      </Modal>
    </Grid>
  );
}
